import React, { Component } from 'react';
import { connect } from 'react-redux';
import SupportTeam from '../SupportTeam';
import { withRouter, Prompt } from 'react-router-dom';
import { actionCreators } from '../../store/Login';
import { bindActionCreators } from 'redux';
import { SalesOrderItems } from './SalesOrderItems';
import { SalesOrderCart } from './SalesOrderCart';
import Export from './SalesOrderPDF';
import { PageHeader, PageHeaderRight, PageHeaderCenter } from '../shared/PageHeader';
import { toast } from 'react-toastify';
import { StoreDropdown } from './StoreDropdown';
import moment from "moment";
import { SingleDatePicker } from 'react-dates';
import 'react-dates/lib/css/_datepicker.css';
import { DateConst, BlankOrderGuideGroup } from '../shared/consts';

export class CreateSalesOrder extends Component {
    displayName = CreateSalesOrder.name;

    constructor(props) {
        super(props);

        this.state = {
            storeId: undefined,
            isAdmin: false,
            loading: true, // initial state
            isPublished: false,
            currOrder: false,
            salesOrderItems: [],
            salesOrderCart: [],
            stores: [],
            orderGuideDeliveryDate: new Date(),
            orderGuideGroup: BlankOrderGuideGroup,
            isDirty: false,
            HoursOfOperationCheck: false,
            tabIndexTop: 0,
            tabIndexBottom: 0,
            orderSubmitted: false,
            submitting: false,
            orderSubmitMessage1: '',
            orderSubmitMessage2: '',
            customDeliveryDate: moment(Date.now() + 1 * 24 * 3600 * 1000),
            originalDeliveryDate: undefined,
            startDeliveryDate: moment(),
            deliveryDateMax: moment(),
            salesOrderRefreshRate: undefined,
            refreshId: 0,
            disableRefreshId: 0,
            sameDayIntervalId: 0,
            openDate: undefined,
            closeDate: undefined,
            deepOpenDate: undefined,
            deepCloseDate: undefined,
            orderCloseWarning: false,
            orderClosed: false,
            customHeaderText: "",
            originalLastPublishedDate: "",
            lastPublishedDate: "",
            conflicts: [],
            refreshActive: false
        };
    }

    componentDidMount = async () => {
        this.setState({ loading: true });
 
        try {
            var d = new Date();
            d.setDate(d.getDate() + 1);
            d.setHours(0);
            d.setMinutes(0);
            d.setSeconds(0);
            var d2 = moment(d);

            this.setState({ startDeliveryDate: d2 });

            const fetchConfig = {
                method: 'GET', headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` }
            };
            const response = await fetch('api/OrderGuideGroups/settings', fetchConfig);
            if (response.ok) {
                let data = await response.json();
                let dateNow = new Date();
                let openDate = new Date();
                let closeDate = new Date();
                var startDate = '', endDate = '', startHour = '', startMinute = '', endHour = '', endMinute = '';
                
                if (this.props.isSameDay === true) {
                    startDate = data.orderGuideGroup.sameDayOrderHoO_Start;
                    endDate = data.orderGuideGroup.sameDayOrderHoO_End;
                }
                else {
                    startDate = data.orderGuideGroup.orderHoO_Start;
                    endDate = data.orderGuideGroup.orderHoO_End;
                }

                if (startDate.length < 7) {
                    startDate = '0' + startDate;
                }

                startHour = (startDate.substring(5, 7) === 'pm' && startDate.substring(0, 2) !== '12') ? (parseInt(startDate.substring(0, 2), 10) + 12) : startDate.substring(0, 2);

                if (startDate.substring(5, 7) === 'am' && startDate.substring(0, 2) === '12') {
                    startHour = '00';
                }

                startMinute = startDate.substring(3, 5);

                if (endDate.length < 7) {
                    endDate = '0' + endDate;
                }

                endHour = (endDate.substring(5, 7) === 'pm' && endDate.substring(0, 2) !== '12') ? (parseInt(endDate.substring(0, 2), 10) + 12) : endDate.substring(0, 2);
                endMinute = endDate.substring(3, 5);

                openDate.setHours(startHour);
                openDate.setMinutes(startMinute);
                openDate.setSeconds(0);
                closeDate.setHours(endHour);
                closeDate.setMinutes(endMinute);
                closeDate.setSeconds(0);

                await this.setState({
                    orderGuideGroup: data.orderGuideGroup,
                    stores: data.assignedStores,
                    openDate: openDate,
                    closeDate: closeDate,
                    deepOpenDate: openDate,
                    deepCloseDate: closeDate,
                    HoursOfOperationCheck: (dateNow > openDate && dateNow < closeDate) ? true : false
                });

                if (this.state.stores && this.state.stores.length > 0) {
                    this.setState({ storeId: this.state.stores[0].storeId });

                    if (this.props.IsSameDay) {
                        var deliveryDate = moment(Date.now());
                    }
                    else {
                        deliveryDate = moment(Date.now() + 1 * 24 * 3600 * 1000);
                    }

                    if (this.props.location.state !== undefined) {
                        var id = this.props.location.state.storeId.replace('S', '');

                        await this.setState({ storeId: id }); 

                        var groupDate = new Date(this.props.location.state.groupDeliveryDate);

                        deliveryDate = moment(groupDate);

                        this.setState({ customDeliveryDate: deliveryDate });
                    }

                    await this.setState({ originalDeliveryDate: deliveryDate });

                    await this.refreshOrder(this.state.storeId, deliveryDate);
                }
                else {
                    // This really shouldn't happen
                    console.log('No stores for Order Guide assigned to this user');
                    toast.error('No stores for Order Guide assigned to this user');
                }
            }
            else if (response.status === 401) {
                toast.error("Unauthorized.");
                this.props.signOut();
            }
            else {
                toast.error(`Error fetching Order Guide settings.`);
                console.log(`Error fetching Order Guide settings: ${await response.text()}.`);
            }
        }
        catch (e) {
            console.log("Error fetching Order Guide settings: " + e);
        }

        this.setState({ loading: false });
    }

    componentWillUnmount = async () => {
        window.clearInterval(this.state.refreshId);
        window.clearInterval(this.state.disableRefreshId);
        window.clearInterval(this.state.sameDayIntervalId);
    }

    sameDayWarning = async () => {
        console.log('SD warning');

        var now = new Date();
        var close = this.state.closeDate;
        var closeWarning = new Date(close - (5 * 60000));

        if (now > closeWarning) {
            this.setState({ orderCloseWarning: true });
        }

        if (now > close) {
            this.setState({ HoursOfOperationCheck: false, orderCloseWarning: false, orderClosed: true });
            window.clearInterval(this.state.refreshId);
            window.clearInterval(this.state.disableRefreshId);
        }
    }

    cancelRefreshJob = async () => {
        var now = new Date();
        var close = this.state.closeDate;
        var closeWarning = new Date(close -  (5 * 60000));

        if (now > closeWarning) {
            this.setState({ orderCloseWarning: true });
        }

        if (now > close) {      
            if (this.state.isDirty) {
                //isAutoSave, IsSave
                this.placeOrder(true, true);
            }

            window.clearInterval(this.state.refreshId);
            window.clearInterval(this.state.disableRefreshId);

            if (this.state.isPublished) {
                let d = moment().format('MM/DD/YYYY h:mm a');
                var delDate = moment(Date.now());
                var submitDate = new Date(delDate.format());
                var dayName = DateConst.days[submitDate.getDay()];
                var submitMessage = 'Order Submitted for ' + dayName + ' ' + delDate.format('MM/DD/YYYY') + ' Delivery.';

                this.setState({ orderSubmitted: true, orderSubmitMessage1: submitMessage, orderSubmitMessage2: d, orderCloseWarning: false, orderClosed: true });   
            }
            else {
                this.setState({ HoursOfOperationCheck: false, orderCloseWarning: false, orderClosed: true });
            }
        }
    }

    refreshJob = async () => {
        if (this.state.isDirty) {
            //isAutoSave, IsSave
            this.placeOrder(true, true);   
        }
    }

    setCurrOrder = () => {
        this.setState({ currOrder: !this.state.currOrder });
    }

    updateRowQuantity = (so) => async (evt) => {
        so.qtyToOrder = evt.target.value;
        so.changed = true;
        await this.setState({ so });

        var soItems = this.state.salesOrderItems.filter((n) => n.qtyToOrder > 0);
        await this.setState({ salesOrderCart: soItems, isDirty: true });
    }

    updateRowOnKeyDown = (so) => async (evt) => {
        if (evt.keyCode === 38 || evt.keyCode === 40) {
            var qty = 0;

            qty = evt.target.value;

            if (evt.keyCode === 38) {
                qty = (parseFloat(evt.target.value) + 1);
            }

            if (evt.keyCode === 40 && evt.target.value > 0) {
                qty = (parseFloat(evt.target.value) - 1);
            }

            if (qty === 0) {
                qty = "";
            }

            so.qtyToOrder = qty;
            so.changed = true;
            await this.setState({ so });

            var soItems = this.state.salesOrderItems.filter((n) => n.qtyToOrder > 0);
            await this.setState({ salesOrderCart: soItems, isDirty: true });
        }
    }

    updateConflictRowQuantity = (so) => async (evt) => {
       
        const soItem = this.state.salesOrderItems.filter((n) => n.productId === so.productId);
        soItem[0].qtyToOrder = evt.target.value;
        soItem[0].changed = true;

        so.dirtyQtyToOrder = evt.target.value;
        so.changed = true;

        await this.setState({ so, soItem });

        var soItems = this.state.salesOrderItems.filter((n) => n.qtyToOrder > 0);
        await this.setState({ salesOrderCart: soItems, isDirty: true });
    }

    updateConflictRowOnKeyDown = (so) => async (evt) => {
        if (evt.keyCode === 38 || evt.keyCode === 40) {
            var qty = 0;

            qty = evt.target.value;

            if (evt.keyCode === 38) {
                qty = (parseFloat(evt.target.value) + 1);
            }

            if (evt.keyCode === 40 && evt.target.value > 0) {
                qty = (parseFloat(evt.target.value) - 1);
            }

            if (qty === 0) {
                qty = "";
            }

            const soItem = this.state.salesOrderItems.filter((n) => n.productId === so.productId);
            soItem[0].qtyToOrder = qty;
            soItem[0].changed = true;

            so.dirtyQtyToOrder = qty;
            so.changed = true;
            await this.setState({ so, soItem });

            var soItems = this.state.salesOrderItems.filter((n) => n.qtyToOrder > 0);
            await this.setState({ salesOrderCart: soItems, isDirty: true });
        }
    }

    updateRowComment = (so) => async (evt) => {
        // used on onBlur so check if change was made
        if (so.storeComments !== evt.target.value) {
            so.storeComments = evt.target.value;
            so.changed = true;
            await this.setState({ so, iSDirty: true });
        }
    }

    zeroRow = (so) => async (evt) => {
        so.qtyToOrder = 0;
        so.changed = true;
        await this.setState({ so });

        var soItems = this.state.salesOrderItems.filter((n) => n.qtyToOrder > 0);
        await this.setState({ salesOrderCart: soItems, isDirty: true });
    }

    saveSalesOrder = async () => {
        var now = new Date();
        var close = this.state.closeDate;

        if (now > close) {
            toast.error("Unable to save Sales Order. Order submission is closed for the day");
            return;
        }

        this.setState({ submitting: true });

        //isAutoSave, IsSave
        this.placeOrder(false, true);
    }

    publishSalesOrder = async () => {
        var now = new Date();
        var close = this.state.closeDate;

        if (now > close) {
            toast.error("Unable to submit Sales Order. Order submission is closed for the day");
            return;
        }

        this.setState({ submitting: true });

        //isAutoSave, IsSave
        this.placeOrder(false, false);
    }

    refreshOrder = async (storeId, selectedDate) => {
        this.props.location.state = null;
        const fetchConfig = {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('token')}`
            }
        };

        const response2 = await fetch('api/SalesOrder/SalesOrder?storeid=' + storeId + '&deliveryDate=' + selectedDate.format(), fetchConfig);
        if (response2.ok) {
            let data2 = await response2.json();

            if (this.props.isSameDay) {
                data2.salesOrder.map(function (x) {
                    x.qtyToOrder = 0;
                    return x;
                });
            }

            if (data2.salesOrder && data2.salesOrder.length > 0) {
                var dataFiltered = data2.salesOrder.filter((n) => n.qtyToOrder > 0);
                this.setState({
                    tabIndexTop: 0,
                    tabIndexBottom: 0,
                    storeId: storeId,
                    salesOrderItems: data2.salesOrder,
                    salesOrderCart: dataFiltered,
                    // Pacific time
                    orderGuideDeliveryDate: data2.orderGuideDeliveryDate,
                    // Pacific time
                    customDeliveryDate: selectedDate,
                    isPublished: data2.isPublished,
                    isDirty: false,
                    //orderSubmitted: false,
                    // Pacific time
                    originalLastPublishDate: data2.lastPublishedDate,
                    // Pacific time
                    lastPublishedDate: data2.lastPublishedDate,
                    // Pacific time
                    //originalDeliveryDate: selectedDate,
                    // Pacific time
                    deliveryDateMax: moment(data2.orderGuideDeliveryDate),
                    salesOrderRefreshRate: data2.salesOrderRefreshRate * 1000,
                    customHeaderText: data2.customHeaderText
                });

                // If date changed check hours of operation
                if (this.state.originalDeliveryDate.date() !== this.state.customDeliveryDate.date()) {
                    this.setState({ HoursOfOperationCheck: true });
                }
                else {
                    let dateNow = new Date();

                    this.setState({ HoursOfOperationCheck: (dateNow > this.state.deepOpenDate && dateNow < this.state.deepCloseDate) ? true : false, openDate: this.state.deepOpenDate, closeDate: this.state.deepCloseDate });
                }

                // Clear and redeclare autosave
                window.clearInterval(this.state.refreshId);
                window.clearInterval(this.state.disableRefreshId);
                window.clearInterval(this.state.sameDayIntervalId);

                var autoSave = ((this.state.orderGuideGroup.allowAutoUpdateOrders && this.state.isPublished) || !this.state.isPublished) ? true : false;

                if (!this.props.isSameDay && autoSave) {
                    let intervalId = window.setInterval(this.refreshJob, data2.salesOrderRefreshRate * 1000);
                    let disableIntervalId = window.setInterval(this.cancelRefreshJob, 5000);

                    this.setState({ refreshId: intervalId, disableRefreshId: disableIntervalId });
                }
                else {
                    let sameDayIntervalId = window.setInterval(this.sameDayWarning, 5000);
                    this.setState({ sameDayIntervalId: sameDayIntervalId });
                }
            }
            else {
                toast.warn(`No Order Guide has been created today for ${this.state.orderGuideGroup.orderGuideGroupName}.`);
            }
        }
    }

    placeOrder = async (isAutoSave, isSave) => {
        const rows = this.state.salesOrderItems.filter((n) => n.changed === true);

        var deliveryDate = moment(Date.now());

        if (!this.state.orderGuideGroup.allowMultipleDayOrderGuide && !this.props.isSameDay) {
            deliveryDate = moment(Date.now()).add(1, 'days');
        }
        if (this.state.orderGuideGroup.allowMultipleDayOrderGuide && !this.props.isSameDay) {
            deliveryDate = this.state.customDeliveryDate;
        }

        var data = {
            "StoreId": this.state.storeId,
            "SalesOrderItems": rows,
            "IsSaveOnly": isSave,
            "IsSameDay": this.props.isSameDay,
            "DeliveryDate": deliveryDate.format(), // Browser datetime with timezone
            "LastPublishedDate": this.state.lastPublishedDate
        };

        const fetchConfig = {
            method: 'PUT',
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('token')}`,
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        };
        const response = await fetch(`api/salesorder/${isSave? "savesalesorder" : "publishsalesorder"}`, fetchConfig);
        if (response.ok) {
            let data2 = await response.json();

            let checkConflicts = false;

            for (var key in data2) {
                if (data2.hasOwnProperty(key))
                    checkConflicts = true;
            }

            if (checkConflicts) {
                if (data2.conflicts.length > 0) {
                    // Disable autosave while there are conflicts
                    window.clearInterval(this.state.refreshId);

                    await this.setState({ hasConflicts: true, isPublished: true, conflicts: data2.conflicts, lastPublishedDate: data2.lastPublishedDate, submitting: false, refreshId: 0, tabIndexTop: 5 });

                    toast.error("Conflicts found.\nA more recent order submission has been found. Please confirm desired order quantity for rows changed since beginning order.", { autoClose: 8000 });

                    return;
                }
            }

            if (!this.props.isSameDay) {
                await this.refreshOrder(this.state.storeId, deliveryDate);
            }

            if (isSave) {
                toast.success(`Sales Order ${!isAutoSave ? "saved." : "autosaved."}`);
                this.setState({ isDirty: false, submitting: false });
            }
            else {
                let d = moment().format('MM/DD/YYYY h:mm a');
                let submitDate = new Date(deliveryDate.format());
                let dayName = DateConst.days[submitDate.getDay()];
                let submitMessage = 'Order Submitted for ' + dayName + ' ' + deliveryDate.format('MM/DD/YYYY') + ' Delivery.';

                toast.success("Sales Order published.");
                this.setState({ isDirty: false, submitting: false, orderSubmitted: true, orderSubmitMessage1: submitMessage, orderSubmitMessage2: d, isPublished: true });
            }
        }
        else {
            toast.error(`Unable to ${isSave ? "save" : "publish"} Sales Order.`);
            console.log(`Unable to ${isSave ? "save" : "publish"} Sales Order: ` + await response.text());
            this.setState({ responseStatus: response.status, submitting: false });
        }
    }

    onChangeStore = async (e) => {
        let storeId = parseInt(e.target.value, 10);

        if (this.state.isDirty) {
            if (!window.confirm("Changes to this Sales Order will be lost. Continue?")) {
                return;
            }
        }

        this.setState({ loading: true });
        var foundStore = this.state.stores.find((store) => {
            return store.storeId === storeId;
        });

        var deliveryDate = moment(Date.now());

        if (!this.state.orderGuideGroup.allowMultipleDayOrderGuide && !this.props.isSameDay) {
            deliveryDate = moment(Date.now() + 1 * 24 * 3600 * 1000);
        }

        if (this.state.orderGuideGroup.allowMultipleDayOrderGuide && !this.props.isSameDay) {
            deliveryDate = this.state.customDeliveryDate;
        }

        await this.refreshOrder(storeId, deliveryDate);
        toast.success("Switched store to " + foundStore.customer_Name);   
        this.setState({ loading: false, storeId: storeId, orderSubmitted: false, hasConflicts: false });
    }

    onChangeDeliveryDate = async (selectedDate) => {
        if (this.state.isDirty) {
            if (!window.confirm("Changes to this Sales Order will be lost. Continue?")) {
                return;
            }
        }

        this.setState({ loading: true });

        await this.refreshOrder(this.state.storeId, selectedDate);
        toast.success("Delivery Date changed to " + selectedDate.format('MM/DD/YYYY'));
  
        this.setState({ loading: false, orderSubmitted: false, hasConflicts: false });
    }

    setTab = (tb) => {
        if (!this.state.hasConflicts) {
            this.setState({ tabIndexTop: tb, tabIndexBottom: tb });
        }
        else {
            this.setState({ tabIndexBottom: tb });
        }
    }

    returnToOrder = async () => {
        if (this.props.isSameDay) {
            var deliveryDate = moment(Date.now());
        }
        else {
            if (!this.state.orderGuideGroup.allowMultipleDayOrderGuide) {
                deliveryDate = moment(Date.now() + 1 * 24 * 3600 * 1000);
            }
            else {
                deliveryDate = this.state.customDeliveryDate;
            }
        }

        await this.refreshOrder(this.state.storeId, deliveryDate);
        this.setState({ orderSubmitted: false, hasConflicts: false });
    }

    returnFromConflicts = () => {
        this.setState({ hasConflicts: false, lastPublishedDate: this.state.originalLastPublishDate, tabIndexTop: 0, tabIndexBottom: 0 });
    }

    render() {
        if (this.state.loading) {
            return <p style={{ padding: '10px' }}><em>Loading...</em></p>;
        }

        var d =(this.props.isSameDay) ? new Date() : (this.state.orderGuideGroup.allowMultipleDayOrderGuide) ? new Date(this.state.customDeliveryDate.format()) : new Date(this.state.orderGuideDeliveryDate);

        var monthName = DateConst.months[d.getMonth()];

        const deliveryDate = monthName + " " + d.getDate().toString() + ", " + d.getFullYear().toString();  

        const showSalesOrderSave = !this.props.isSameDay && !this.state.isPublished && !this.state.hasConflicts;
        const orderAvailable = this.state.HoursOfOperationCheck && this.state.salesOrderItems.length !== 0  && !this.state.loading;
        const orderPublished = this.state.salesOrderItems.length !== 0 && !this.state.loading;
        const allowMultipleDayOrderGuide = !this.props.isSameDay && this.state.orderGuideGroup.allowMultipleDayOrderGuide;

        return (
            <div>
                {!this.state.loading &&
                    <PageHeader pageTitle={this.props.isSameDay === true ? "Same Day Sales Order" : "Sales Order"}
                        pageHeaderCenter={
                            <PageHeaderCenter>
                                {this.state.customHeaderText === "" &&
                                    <React.Fragment>
                                        <span>Delivery for </span> {deliveryDate}
                                    </React.Fragment>
                                }
                                {this.state.customHeaderText !== "" &&
                                    <React.Fragment>
                                       
                                        <span>{this.state.customHeaderText}</span>
                                    </React.Fragment>
                                }
                            </PageHeaderCenter>
                        }
                        pageHeaderRight={
                            <PageHeaderRight>                  
                                <div style={{ display: 'inline-block', height: '24px' }} >
                                    {allowMultipleDayOrderGuide &&
                                        <div style={{ marginRight: '10px', display: 'inline-block', height: '24px', verticalAlign: 'top' }}>
                                            <span>Set Delivery Date: </span>
                                            <SingleDatePicker
                                                date={this.state.customDeliveryDate}
                                                onDateChange={customDeliveryDate => this.onChangeDeliveryDate(customDeliveryDate)}
                                                focused={this.state.focused}
                                                onFocusChange={({ focused }) => this.setState({ focused })}
                                                id="your_unique_id"
                                                isOutsideRange={(currDate) => currDate.isBefore(this.state.startDeliveryDate, 'day') || currDate.isAfter(this.state.deliveryDateMax, 'day')}
                                                numberOfMonths={1}
                                                readOnly            
                                            /> 
                                        </div>
                                    }     
                                    <StoreDropdown
                                        onChangeStore={this.onChangeStore}
                                        storeId={this.state.storeId}
                                        stores={this.state.stores}
                                    />
                                </div>               
                                <Export
                                    orderGuideGroup={this.state.orderGuideGroup}
                                    salesOrderItems={this.state.salesOrderItems}
                                    updateRow={this.updateRow}
                                    currOrder={this.state.currOrder}
                                    showPDF={orderAvailable}
                                />
                            </PageHeaderRight>
                        }
                    />
                }
                {!orderPublished &&
                    <div>
                        <h3>Order Guide has not been published.</h3>
                    </div>
                }
                {!orderAvailable &&
                    <div>
                        {this.props.isSameDay &&
                            <h2>Sorry. Same-Day Deliveries are closed for the day.</h2>
                        }
                        {!this.props.isSameDay && this.state.salesOrderItems.length !== 0 &&
                            <h2>Sorry. Sales Orders are closed for the day.</h2>
                        }
                        <h3>Please contact your OGC Sales rep.</h3>
                    </div>
                }
                {this.state.orderCloseWarning &&
                    <div className="problem" style={{ height: '25px' }}>
                        <div>
                            <div style={{ display: 'inline-block', color: 'white', textAlign: 'center' }}>
                                <div style={{ fontSize: '16px' }}>
                                    <span>Please complete your order. Submission closes at </span>
                                     {this.props.isSameDay === true &&
                                        this.state.orderGuideGroup.sameDayOrderHoO_End
                                    }
                                    {this.props.isSameDay === false &&
                                        this.state.orderGuideGroup.orderHoO_End
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                }
                {orderAvailable &&
                    <div>
                        <div>
                            <SalesOrderItems
                                orderGuideGroup={this.state.orderGuideGroup}
                                salesOrderItems={this.state.salesOrderItems}
                                updateRowQuantity={this.updateRowQuantity}
                                updateRowOnKeyDown={this.updateRowOnKeyDown}
                                updateRowComment={this.updateRowComment}
                                currOrder={this.state.currOrder}
                                orderSubmitted={this.state.orderSubmitted}
                                tabIndex={this.state.tabIndexTop}
                                setTab={this.setTab}
                                hasConflicts={this.state.hasConflicts}
                                conflicts={this.state.conflicts}
                                updateConflictRowQuantity={this.updateConflictRowQuantity}
                                updateConflictRowOnKeyDown={this.updateConflictRowOnKeyDown}
                            />
                        </div>
                        {!this.state.orderSubmitted &&
                        <div className="problem">
                            <div>
                                <div style={{ display: 'inline-block' }}>
                                    {showSalesOrderSave &&
                                        <input type="button" className={(this.state.isDirty) ? "orderGuideButton" : "orderGuideDisbledButton"} onClick={this.saveSalesOrder} value="Save Cart" disabled={this.state.submitting || !this.state.isDirty} />
                                    }
                                    {this.state.hasConflicts &&
                                        <React.Fragment>
                                            <input type="button" className="orderGuideButton" onClick={this.returnToOrder} value="Cancel All Changes" disabled={this.state.submitting} />
                                            <input type="button" className="orderGuideButton" onClick={this.returnFromConflicts} value="Return to Sales Order" disabled={this.state.submitting} />
                                        </React.Fragment>
                                    }
                                        <input type="button" className={(!this.state.isPublished) ? "orderGuideButton" : (this.state.isDirty) ? "orderGuideButton" : "orderGuideDisbledButton"} onClick={this.publishSalesOrder} value={(!this.state.hasConflicts) ? (!this.state.isPublished) ? "Place Order" : "Update Order" : "Force Order"} disabled={(!this.state.isPublished) ? false : (this.state.submitting || !this.state.isDirty)} />                               
                                </div>
                                <div style={{ display: 'inline-block', float: 'right', margin: '5px' }}>
                                    <input type="button" className="ogcButton" onClick={this.setCurrOrder} value={"Current Order (" + this.state.salesOrderCart.length + ")"} />
                                </div>
                            </div>
                        </div>   
                        }
                        {this.state.orderSubmitted &&
                            <div className="problem" style={{ height: '50px'}}>
                                <div>             
                                    <div style={{display: 'inline-block', color: 'white', textAlign: 'center' }}>
                                        <div style={{fontSize: '16px'}}>{this.state.orderSubmitMessage1}</div>                                  
                                        <div style={{fontSize: '12px'}}>{this.state.orderSubmitMessage2}</div>
                                    </div>
                                    <div style={{ display: 'inline-block', float: 'right', margin: '5px' }}>
                                    {!this.props.isSameDay &&
                                        <React.Fragment>
                                            {!this.state.orderClosed &&
                                                <input type="button" className="ogcButton" onClick={this.returnToOrder} value={"Return to Order"} />
                                            }
                                        </React.Fragment>
                                    }
                                    </div>
                                </div>
                            </div>
                        }                    
                        <SalesOrderCart
                            orderGuideGroup={this.state.orderGuideGroup}
                            zeroRow={this.zeroRow}
                            salesOrderCart={this.state.salesOrderCart}
                            currOrder={this.state.currOrder}
                            orderSubmitted={this.state.orderSubmitted}
                            tabIndex={this.state.tabIndexBottom}
                            setTab={this.setTab}
                            hasConflicts={this.state.hasConflicts}
                            conflicts={this.state.conflicts}
                        />                      
                    </div>
                }
                <SupportTeam isEditHome={false} />
                <Prompt when={this.state.isDirty} message="Changes to this Sales Order will be lost. Continue?" />
            </div>
        );
    }
}
export default withRouter(connect(state => state.login,
    dispatch => bindActionCreators(actionCreators, dispatch)
)(CreateSalesOrder));


// WEBPACK FOOTER //
// ./src/components/SalesOrder/CreateSalesOrder.js